const protocolText = `
感谢您使用网约巴士线上购票服务！在使用前，请您仔细阅读以下内容，使用本服务购票即表示您接受并遵守以下条款。<br/>

<b>购票规则</b><br/>
1.请您在提交订单前仔细核对所购车票的乘车站名称、目的地、票价和乘车人数等，确认无误后提交并付款。<br/>
2.网约巴士在区域内行驶没有固定路线和时刻，建议在车站附近下单候车，避免错过。<br/>

<b>退票规则</b><br/>
1.订单完成前，乘客可自行申请退票。<br/>
2.订单在进行过程中因车辆故障、驾驶员没法正常驾驶或突发交通意外，乘客可申请退票。<br/>
3.为避免影响其他乘客体验和恶意订单干扰，乘客在车辆到站后没有上车或取消订单，司机将关闭此订单，且平台不提供退票处理。<br/>
4.如多次退票，可能被加入黑名单禁止买票。<br/>
5.退款手续费：无退款手续费。<br/>

<b>乘车须知</b><br/>
（一）网约巴士具有拼车性质，会出现顺路接单情况，请留意车辆位置，耐心等候。车辆座位按照先到先得原则。<br/>

（二）乘车应讲究文明礼貌，主动礼让老、幼、病、残、孕妇及怀抱婴儿者优先登乘，不得在车内有高声喧哗、打闹、赤膊、乞讨、赌博、卖唱等不文明行为，不得有危及他人人身安全的行为。<br/>

（三）车辆保持车厢清洁，不得在车内吸烟、随地吐痰、吐口香糖、乱丢废弃物等。在行驶过程中因事故不能继续运行时，应服从驾乘人员的指挥安排换乘其他车辆。到达终点后乘客应拿齐物品下车，禁止随车返回。<br/>

（四）一名成年人可以免费携带两名身高不超过1.3米或未达到法定入学年龄的儿童（凭有效身份证件）乘车；所带儿童超过两名的，按超过规定人数购票。<br/>

（五）乘客应接受工作人员查验票，未按规定验票的，驾驶员（乘务员）可以拒绝为其提供客运服务。<br/>

（六）一名乘客可以免费携带总重量不超过30公斤且体积不超过0.1立方米、高度（长度）不超过1.6米的行李物品。携带物品重量超过30公斤或体积超过0.1立方米或高度（长度）超过1.6米的，不得携带乘车（婴儿车、残疾人使用的轮椅、导盲杆等必要扶助工具，以及未超过以上行李规格的折叠单车除外）。乘客应注意保管好随身携带的物品，严防被盗，行李物品不能占用座位、不得阻碍通道（婴儿车、折叠单车、轮椅等应妥善折叠）。<br/>

（七）禁止携带易燃、易爆（易碎）、有毒、放射性、腐蚀性、有刺激性气味以及其它可能污损车辆、危及行车安全或危害他人人身安全的物品（含充气气球）乘车。禁止携带活体禽、畜、宠物等动物（有识别标志、且采取保护措施的导盲犬、扶助犬除外）上车；携带物体有一定重量、体积或贵重物品乘车时，应将物品妥善包装保管，如因自身保管不善而造成的伤害及损失，由乘客承担。<br/>

（八）醉酒者、精神病患者、危重病患者、行动不便者及学龄前儿童，须在有监护能力的健康成年人陪同下乘坐交通工具，因监护人责任在车上造成的伤害及损失的，由监护人承担。醉酒者、精神病患者、学龄前儿童及行动不便者，须有监护能力的健康成年人陪同乘车，因监护人责任在车上造成的伤害及损失的，由监护人承担。<br/>

（九）乘客应在规定的车站有序上下车，车辆未到站时不得示意驾驶员停车，行车时不得有与驾驶员闲谈等妨碍驾驶员驾驶及影响行车安全的行为，不得随意移动或者破坏车内消防、安全器材。<br/>

（十）车辆营运途中，遇有涉嫌违法犯罪行为等紧急事件时应听从驾驶员（乘务人员）指挥，按照乘车应急指引、处置突发事件；禁止将身体的任何部位伸出车辆外，禁止自行开关车辆闸门及进行其他妨碍车辆行驶、停靠和乘客安全的活动。<br/>

（十一）乘客应当爱护车内设施，损坏车内设施、设备、物品的，应依法承担赔偿责任。<br/>

（十二）讲文明讲礼貌，乘客应自觉维护公共卫生、禁止随地乱丢垃圾、禁止乱张贴及涂鸦；自觉维护公共秩序，乘客自身过错造成伤亡事故或财产损失的，由其自行承担责任；造成车辆营运损失以及伤害他人的，依法追究其法律责任。禁止躺、卧、占据、蹬踏座位，禁止妨碍驾乘人员工作。<br/>

（十三）违反城市客运管理相关法规规定，经劝阻拒不改正的，驾驶员交通运输经营单位可以拒绝为其提供客运服务，并告知有关行政管理部门。<br/>

（十四）扰乱公共秩序构成违反治安管理法规的，按照相关法律的规定移送相关部门依法处理；构成犯罪的，移送司法机关依法追究刑事责任。<br/>

（十五）乘客可积极参与巴士营运服务管理的监督。在乘坐过程中如有意见或建议，可致电83833333进行投诉反映。<br/>
`

const protocolText021 = `
感谢您使用优约巴士线上购票服务！在使用前，请您仔细阅读以下内容，使用本服务购票即表示您接受并遵守以下条款。 <br/>

<b>购票规则</b><br/>
1.请您在提交订单前仔细核对所购车票的乘车站名称、目的地、票价和乘车人数等，确认无误后提交并付款。<br/>
2.优约巴士在区域内行驶没有固定路线和时刻，建议在车站附近下单候车，避免错过。<br/>

<b>退票规则</b><br/>
1、在车辆到站前，乘客可自行申请退票<br/>
2、为避免影响其他乘客体验和恶意订单干扰，乘客在车辆到站后没有上车或取消订单，司机将关闭此订单，且平台不提供退票处理。<br/>
3、如多次退票，可能被加入黑名单禁止买票。<br/>
4、退票无需手续费，退票票款将在3个工作日内退回。<br/>

<b>乘车须知</b><br/>
（一）优约巴士具有拼车性质，会出现顺路接单情况，请留意车辆位置，耐心等候。车辆座位按照先到先得原则。<br/>

（二）乘车应讲究文明礼貌，主动礼让老、幼、病、残、孕妇及怀抱婴儿者优先登乘，不得在车内有高声喧哗、打闹、赤膊、乞讨、赌博、卖唱等不文明行为，不得有危及他人人身安全的行为。<br/>

（三）车辆保持车厢清洁，不得在车内吸烟、随地吐痰、吐口香糖、乱丢废弃物等。在行驶过程中因事故不能继续运行时，应服从驾乘人员的指挥安排换乘其他车辆。到达终点后乘客应拿齐物品下车，禁止随车返回。<br/>

（四）一名成年乘客可免费携带一名身高不足1.2米的儿童。<br/>

（五）乘客应接受驾驶员查验票，未按规定验票的，驾驶员可以拒绝为其提供客运服务。<br/>

（六）一名乘客可以免费携带总重量不超过10公斤且体积不超过0.05立方米、高度（长度）不超过1.6米的行李物品（婴儿车、残疾人使用的轮椅、导盲杆等必要扶助工具，以及未超过以上行李规格的折叠单车除外）。乘客应注意保管好随身携带的物品，严防被盗，行李物品不能占用座位、不得阻碍通道（婴儿车、折叠单车、轮椅等应妥善折叠）。<br/>

（七）禁止携带易燃、易爆（易碎）、有毒、放射性、腐蚀性、有刺激性气味以及其它可能污损车辆、危及行车安全或危害他人人身安全的物品（含充气气球）乘车。禁止携带活体禽、畜、宠物等动物（有识别标志、且采取保护措施的导盲犬、扶助犬除外）上车；携带物品乘车时，应妥善保管，如因自身保管不善而造成的伤害及损失，由物品携带乘客自行承担。<br/>

（八）醉酒者、精神病患者、危重病患者、行动不便者及学龄前儿童，须在有监护能力的健康成年人陪同下乘坐交通工具，因监护人责任在车上造成的伤害及损失的，由监护人承担。<br/>

（九）乘客应在规定的车站有序上下车，车辆未到站时不得示意驾驶员停车，行车时不得有与驾驶员闲谈等妨碍驾驶员驾驶及影响行车安全的行为，不得随意移动或者破坏车内设施设备。<br/>

（十）车辆营运途中，遇有涉嫌违法犯罪行为等紧急事件时应听从驾驶员指挥，按照乘车应急指引、处置突发事件；禁止将身体的任何部位伸出车辆外，禁止自行开关车辆闸门及进行其他妨碍车辆行驶、停靠和乘客安全的活动。<br/>

（十一）乘客应当爱护车内设施，损坏车内设施、设备、物品的，应依法承担赔偿责任。<br/>

（十二）讲文明讲礼貌，乘客应自觉维护公共卫生、禁止随地乱丢垃圾、禁止乱张贴及涂鸦；自觉维护公共秩序，乘客自身过错造成伤亡事故或财产损失的，由其自行承担责任；造成车辆营运损失以及伤害他人的，依法追究其法律责任。禁止躺、卧、占据、蹬踏座位，禁止妨碍驾乘人员工作。<br/>

（十三）违反城市客运管理相关法规规定，经劝阻拒不改正的，驾驶员交通运输经营单位可以拒绝为其提供客运服务，并告知有关行政管理部门。<br/>

（十四）扰乱公共秩序构成违反治安管理法规的，按照相关法律的规定移送相关部门依法处理；构成犯罪的，移送司法机关依法追究刑事责任。<br/>


（十五）乘车票据，乘客可在上车后向驾驶员索取对应金额的发票。<br/>

（十六）服务咨询电话：87330663，查询网址：www.zsbus.cn，或关注“中山公交集团”微信公众号。<br/>
`

const protocolText008 = `
感谢您使用随需公交线上购票服务！在使用前，请您仔细阅读以下内容，使用本服务购票即表示您接受并遵守以下条款。<br/>
<b>购票规则</b><br/>
1.请您在提交订单前仔细核对所购车票的乘车站名称、目的地、票价和乘车人数等，确认无误后提交并付款。<br/>
2.随需公交没有固定发车时刻，会在收到订单后尽快安排车辆，建议在下单后注意时间，提前候车，避免错过。<br/>
<b>退票规则</b><br/>
1.订单完成前，乘客可自行申请退票。<br/>
2.订单在进行过程中因车辆故障、驾驶员没法正常驾驶或突发交通意外，乘客可申请退票。<br/>
3.为避免影响其他乘客体验和恶意订单干扰，乘客在车辆到站后没有上车或取消订单，司机将关闭此订单，且平台不提供退票处理。<br/>
4.如多次退票，可能被加入黑名单禁止买票。<br/>
5.退款手续费：无退款手续费。<br/>
<b>乘车须知</b><br/>
（一）随需公交具有拼车性质，会出现顺路接单情况，请留意车辆位置，耐心等候。车辆座位按照先到先得原则。<br/>
（二）乘车应讲究文明礼貌，主动礼让老、幼、病、残、孕妇及怀抱婴儿者优先登乘，不得在车内有高声喧哗、打闹、赤膊、乞讨、赌博、卖唱等不文明行为，不得有危及他人人身安全的行为。<br/>
（三）车辆保持车厢清洁，不得在车内吸烟、随地吐痰、吐口香糖、乱丢废弃物等。在行驶过程中因事故不能继续运行时，应服从驾乘人员的指挥安排换乘其他车辆。到达终点后乘客应拿齐物品下车，禁止随车返回。<br/>
（四）一名成年人可以免费携带两名身高不超过1.3米或未达到法定入学年龄的儿童（凭有效身份证件）乘车；所带儿童超过两名的，按超过规定人数购票。<br/>
（五）乘客应接受工作人员查验票，未按规定验票的，驾驶员（乘务员）可以拒绝为其提供客运服务。乘客中途下车，造成漏乘、错乘的，我司不承担责任。<br/>
（六）一名乘客可以免费携带总重量不超过30公斤且体积不超过0.1立方米、高度（长度）不超过1.6米的行李物品。不得携带重量超过30公斤或体积超过0.1立方米或高度（长度）超过1.6米的物品乘车（婴儿车、残疾人使用的轮椅、导盲杆等必要扶助工具，以及未超过以上行李规格的折叠单车除外）。乘客应注意保管好随身携带的物品，严防被盗，行李物品不能占用座位、不得阻碍通道（婴儿车、折叠单车、轮椅等应妥善折叠）。<br/>
（七）禁止携带易燃、易爆（易碎）、有毒、放射性、腐蚀性、有刺激性气味以及其它可能污损车辆、危及行车安全或危害他人人身安全的物品（含充气气球）乘车。禁止携带活体禽、畜、宠物等动物（有识别标志、且采取保护措施的导盲犬、扶助犬除外）上车；携带物体有一定重量、体积或贵重物品乘车时，应将物品妥善包装保管，如因自身保管不善而造成的伤害及损失，由乘客承担。<br/>
（八）醉酒者、精神病患者、危重病患者、行动不便者及学龄前儿童，须在有监护能力的健康成年人陪同下乘坐交通工具，因监护人责任在车上造成的伤害及损失的，由监护人承担。醉酒者、精神病患者、学龄前儿童及行动不便者，须有监护能力的健康成年人陪同乘车，因监护人责任在车上造成的伤害及损失的，由监护人承担。<br/>
（九）乘客应在规定的车站有序上下车，车辆未到站时不得示意驾驶员停车，行车时不得有与驾驶员闲谈等妨碍驾驶员驾驶及影响行车安全的行为，不得随意移动或者破坏车内消防、安全器材。<br/>
（十）车辆营运途中，遇有涉嫌违法犯罪行为等紧急事件时应听从驾驶员（乘务人员）指挥，按照乘车应急指引、处置突发事件；禁止将身体的任何部位伸出车辆外，禁止自行开关车辆闸门及进行其他妨碍车辆行驶、停靠和乘客安全的活动。<br/>
（十一）乘客应当爱护车内设施，损坏车内设施、设备、物品的，应依法承担赔偿责任。<br/>
（十二）讲文明讲礼貌，乘客应自觉维护公共卫生、禁止随地乱丢垃圾、禁止乱张贴及涂鸦；自觉维护公共秩序，乘客自身过错造成伤亡事故或财产损失的，由其自行承担责任；造成车辆营运损失以及伤害他人的，依法追究其法律责任。禁止躺、卧、占据、蹬踏座位，禁止妨碍驾乘人员工作。<br/>
（十三）违反城市客运管理相关法规规定，经劝阻拒不改正的，驾驶员交通运输经营单位可以拒绝为其提供客运服务，并告知有关行政管理部门。<br/>
（十四）扰乱公共秩序构成违反治安管理法规的，按照相关法律的规定移送相关部门依法处理；构成犯罪的，移送司法机关依法追究刑事责任。<br/>
（十五）其他未尽事宜，参照《东莞市公共汽车乘车守则》。<br/>
（十六）乘客可积极参与巴士营运服务管理的监督，如有意见或建议，可致电960163进行反映。<br/>
`

export const getProtocolContent = cityId => {
  if (cityId === '021') {
    return protocolText021
  }
  if (cityId === '008') {
    return protocolText008
  }
  return protocolText
}

export const getProtocolTitle = cityId => {
  if (cityId === '008') {
    return '随需公交购票协议'
  }
  return '网约巴士购票协议'
}

